<app-page-bar></app-page-bar>

<app-page>
  <section>

    <mat-card class="app-card">
      <mat-card-header>
        <mat-card-title>Lead Sources</mat-card-title>
      </mat-card-header>

      <mat-card-content>

        <div class="filter">
          <mat-icon class="app-mat-icon-signifier">filter_list</mat-icon>
          <app-text-list-filter [list]="leadSources"></app-text-list-filter>
          <app-reset-list-filter [list]="leadSources"></app-reset-list-filter>
        </div>

        <mat-table [dataSource]="leadSources" matSort
          (matSortChange)="leadSources.setSort($event.active, $event.direction)" matSortDisableClear="true"
          [matSortActive]="leadSources.state.sort.key" [matSortDirection]="leadSources.state.sort.direction">

          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Name</mat-header-cell>
            <mat-cell *matCellDef="let element">{{element.name}}</mat-cell>
          </ng-container>

          <!--
        <ng-container matColumnDef="businessId">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Business ID</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.businessId}}</mat-cell>
        </ng-container>
        -->

          <ng-container matColumnDef="created">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Created</mat-header-cell>
            <mat-cell *matCellDef="let element">{{element.created | date}}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let element">
              <mat-icon>arrow_forward</mat-icon>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: columns;" matRipple
            [routerLink]="['/settings/lead-sources', row.leadSourceId]"></mat-row>

        </mat-table>

        <mat-paginator [length]="leadSources.total" [pageIndex]="leadSources.state.pager.page - 1"
          [pageSize]="leadSources.state.pager.size" [pageSizeOptions]="[5, 10, 25, 100]"
          (page)="leadSources.setPage($event.pageIndex + 1, $event.pageSize)">
        </mat-paginator>
      </mat-card-content>
    </mat-card>

  </section>
  <div class="fab-bottom-right">
    <a mat-fab routerLink="/settings/lead-sources/new" color="primary" aria-label="Add a lead source">
      <mat-icon>add</mat-icon>
    </a>
  </div>
</app-page>
